import { render, staticRenderFns } from "./DownloadRequest.vue?vue&type=template&id=14049ce2&scoped=true&"
import script from "./DownloadRequest.vue?vue&type=script&lang=js&"
export * from "./DownloadRequest.vue?vue&type=script&lang=js&"
import style0 from "./DownloadRequest.vue?vue&type=style&index=0&id=14049ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14049ce2",
  null
  
)

export default component.exports